export default [{"url":"https://adegboye-0.api.invexerp.io","name":"Branch 1","port":"5050","isStore":true,"isHQ":true}]